import * as React from 'react'
import { IGlobalSettingsListState } from '../../types/global-settings'
import SettingsGroup from './SettingsGroups'

export default class GlobalSettingsList extends React.Component {
  public settings: IGlobalSettingsListState = [
    [
      {
        title: 'Services',
        directories: [
          {
            label: 'Service Program',
            href: '/global-settings/service-program'
          }
        ]
      },
      {
        title: 'Providers',
        directories: [
          {
            label: 'Service Level',
            href: '/global-settings/service-level'
          }
        ]
      },
      {
        title: 'Vehicles',
        directories: [
          {
            label: 'Accommodations',
            href: '/global-settings/accommodations'
          },
          {
            label: 'Vehicle Type',
            href: '/global-settings/vehicle-type'
          },
          {
            label: 'Make',
            href: '/global-settings/make'
          },
          {
            label: 'Model',
            href: '/global-settings/model'
          },
          {
            label: 'Color',
            href: '/global-settings/color'
          }
        ]
      }
    ],
    [
      {
        title: 'Mobility',
        directories: [
          {
            label: 'Mobility Devices',
            href: '/global-settings/mobility-devices'
          },
          {
            label: 'Mobility Category',
            href: '/global-settings/mobility-category'
          }
        ]
      },
      {
        title: 'Assistance',
        directories: [
          {
            label: 'Assistance',
            href: '/global-settings/assistance'
          },
          {
            label: 'Assistance Category',
            href: '/global-settings/assistance-category'
          }
        ]
      }
    ]
  ]

  public render() {
    return (
      <div className='pt3'>
        <div className='flex justify-between mb2'>
          <div className='pl3 h3 bold font-blue-grey'>Global Settings</div>
        </div>
        <hr />
        <div className='p2'>
          {this.settings.map((settingsList, index) => (
            <div className='col col-2 mr3' key={`settings_group_col_${index}`}>
              {settingsList.map((settingsGroup, groupIndex) => (
                <SettingsGroup key={`settings_group_${groupIndex}_${index}`} {...settingsGroup} />
              ))}
            </div>
          ))}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/GlobalSettingsList.tsx